import React from 'react';
import { Card, CardBody, Container } from 'reactstrap';
import PropTypes from 'prop-types';

function smartCard(props) {
  const { title, children } = props;
  return (
    <Container className="smart-card">
      <Card>
        <CardBody>
          {title ? (
            <div className="card__title">
              <h5 className="bold-text">{title}</h5>
            </div>
          ) : null}
          {children}
        </CardBody>
      </Card>
    </Container>
  );
}

smartCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

smartCard.defaultProps = {
  title: '',
  children: [],
};

export default smartCard;
